import {
  createJSONStorage,
  atomWithStorage as jotaiAtomWithStorage,
} from 'jotai/utils';

function atomWithSessionStorage<T>(
  key: string,
  initialValue: T,
): ReturnType<typeof jotaiAtomWithStorage<T>> {
  const storage = createJSONStorage<T>(() => sessionStorage);
  return jotaiAtomWithStorage(key, initialValue, storage);
}

export { atomWithSessionStorage };
